<template>
  <div v-if="!isChartFilterError" class="usage-table">
    <VsLoader :visible="!!usageData.isLoading" />
    <div class="box">
      {{ "charts.dataTable" | t }}
      <a
        v-if="validUsageData && validUsageData.length > 0"
        ref="csvDownloadLink"
        class="button download-button is-pulled-right"
        :download="csvFileName"
        @click="downloadCsv"
      >
        <font-awesome-icon class="vs-icon" icon="file-download" />
        {{ "charts.itemCoverageChart.downloadCSV" | t }}</a
      >
    </div>
    <DataTableBody :activeUsage="activeUsage" :validUsageData="validUsageData" :tableColumns="tableColumns" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { USAGE_DEFINITION } from "@/misc/desktopCharts";
import DataTableBody from "./DataTableBody";
import CsvHelper from "@/lib/csvHelper";
const ACNE_STORE_ID = 54;

export default {
  components: {
    DataTableBody,
  },
  props: {
    activeUsage: {
      type: String,
      required: true,
    },
    usageData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isChartFilterError() {
      const data = this.usageData;
      return Object.keys(data).some((key) => data[key]?.rateData?.isError || data[key]?.valueData?.isError);
    },
    ...mapGetters({
      currentStore: "user/getCurrentStore",
    }),
    csvFileName() {
      return `${this.currentStore.name}.csv`;
    },
    tableColumns() {
      let columns = [
        {
          colname: "date",
          label: "charts.usagePageCharts.date",
          width: "40",
          name: "ts",
          type: "date",
          class: "date-time",
        },
      ];
      USAGE_DEFINITION.filter((usage) => {
        return !usage.disabled && !this.usageData[usage.name].isError;
      }).forEach((usage) => {
        columns.push({
          colname: usage.name + "Value",
          label: usage.valueTitle,
          name: usage.name,
          type: "valueData",
          format: "0,0",
          class: "value",
        });
        columns.push({
          colname: usage.name + "Rate",
          label: usage.rateTitle,
          name: usage.name,
          type: "rateData",
          format: "0.00%",
          class: "value",
        });
      });
      return columns;
    },
    isLoading() {
      for (let usageKey in this.usageData) {
        if (this.usageData[usageKey].isLoading) {
          return true;
        }
      }
      return false;
    },
    validUsageData() {
      if (this.isLoading || !this.tableColumns || this.tableColumns.length === 0) {
        return [];
      }
      let baseLoop = this.usageData[this.tableColumns[1].name].valueData;
      let _this = this;
      return baseLoop.map((usageData, index) => {
        let tableItem = {
          date: usageData.date,
        };
        _this.tableColumns.forEach((column) => {
          if (_this.usageData[column.name]) {
            if (this.invalidValue(column.colname)) {
              tableItem[column.colname] = "-";
            } else {
              tableItem[column.colname] = _this.usageData[column.name][column.type][index]
                ? _this.usageData[column.name][column.type][index].val
                : 0;
            }
          }
        });
        return tableItem;
      });
    },
  },
  methods: {
    invalidValue(columnName) {
      return this.currentStore.store_id === ACNE_STORE_ID && columnName.search("sales") >= 0;
    },
    downloadCsv() {
      const fields = this.tableColumns.map((column) => {
        return {
          label: this.$t(column.label),
          value: column.colname,
        };
      });
      const dateFormatChanged = this.validUsageData.map((usage) => {
        let newObg = {
          ...usage,
          ts: this.$options.filters.dateFormat(usage.ts, "yyyy/MM/dd", false),
        };
        return newObg;
      });
      const helper = new CsvHelper();
      this.$refs.csvDownloadLink.href = helper.createFileURL(dateFormatChanged, fields);
    },
  },
};
</script>

<style scoped lang="scss">
.usage-table {
  min-height: 300px;

  .box {
    margin-right: 1px;
    margin-bottom: 0;
    margin-left: 1px;
    border-radius: 0;
    font-weight: 400;
    font-size: 20px;
  }

  .vs-icon {
    margin-right: 5px;
  }

  .download-button {
    font-size: 13px;
  }
}
</style>
